// import { useState } from "react";
// import { retrieveCustomerServiceDetails } from "../hooks/api";

// interface CreateCampaignSidebarProps {
//   isOpen: boolean;
//   onClose: () => void;
//   collections: Collection[];
// }

// interface Collection {
//   id: number | string;
//   name: string;
// }


// export function CreateCampaignSidebar({ 
//   isOpen, 
//   onClose,
//   collections = [],
// }: CreateCampaignSidebarProps) {
//   const [name, setName] = useState("");
//   const [collection, setCollection] = useState<string | number>("");
//   const [fromDate, setFromDate] = useState<string>(new Date().toISOString().split('T')[0]);
//   const [toDate, setToDate] = useState<string>(new Date().toISOString().split('T')[0]);
//   const [isCreating, setIsCreating] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [success, setSuccess] = useState<string | null>(null);

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setError(null);
//     setSuccess(null);
    
//     if (!name.trim()) {
//       setError("Campaign name is required");
//       return;
//     }
    
//     if (!collection) {
//       setError("Please select a collection");
//       return;
//     }
    
//     if (!fromDate || !toDate) {
//       setError("Please select both start and end dates");
//       return;
//     }
    
//     if (new Date(toDate) < new Date(fromDate)) {
//       setError("End date cannot be before start date");
//       return;
//     }
    
//     setIsCreating(true);
    
//     try {
//       const result = await retrieveCustomerServiceDetails({
//         fromDate,
//         toDate,
//         result_collection: name,
//       });
      
//       setSuccess(`Campaign "${name}" created successfully! ${result.count} records retrieved.`);
      
//       // Reset form
//       setName("");
//       setCollection("");
//       setFromDate(new Date().toISOString().split('T')[0]);
//       setToDate(new Date().toISOString().split('T')[0]);
      
//       // Close sidebar after a short delay to allow user to see success message
//       setTimeout(() => {
//         onClose();
//         setSuccess(null);
//       }, 2000);
//     } catch (error) {
//       console.error("Error creating campaign:", error);
//       setError("Failed to create campaign. Please try again.");
//     } finally {
//       setIsCreating(false);
//     }
//   };

//   return (
//     <>
//       {/* Backdrop */}
//       {isOpen && (
//         <div 
//           className="fixed inset-0 bg-primary bg-opacity-30 backdrop-blur-sm z-40 animate-fade-in"
//           onClick={onClose}
//         />
//       )}
      
//       {/* Sidebar */}
//       <div 
//         className={`fixed top-0 right-0 z-50 h-full w-96 max-w-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
//           isOpen ? "translate-x-0" : "translate-x-full"
//         }`}
//       >
//         <div className="flex items-center justify-between p-6 border-b">
//           <h2 className="text-xl font-semibold">Create Campaign</h2>
//           <button 
//             onClick={onClose} 
//             className="h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100"
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//               <line x1="18" y1="6" x2="6" y2="18"></line>
//               <line x1="6" y1="6" x2="18" y2="18"></line>
//             </svg>
//           </button>
//         </div>
        
//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
//           {error && (
//             <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-md">
//               {error}
//             </div>
//           )}
          
//           {success && (
//             <div className="p-3 bg-green-50 border border-green-200 text-green-700 rounded-md">
//               {success}
//             </div>
//           )}
          
//           <div className="space-y-2">
//             <label htmlFor="name" className="block text-sm font-medium text-gray-700">
//               Campaign Name
//             </label>
//             <input
//               id="name"
//               type="text"
//               placeholder="Enter campaign name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
          
//           <div className="space-y-2">
//             <label htmlFor="collection" className="block text-sm font-medium text-gray-700">
//               Collection
//             </label>
//             <select 
//               id="collection" 
//               value={collection.toString()} 
//               onChange={(e) => setCollection(e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="" disabled>Select a collection</option>
//               {collections.map((col) => (
//                 <option key={col.id.toString()} value={col.id.toString()}>
//                   {col.name}
//                 </option>
//               ))}
//             </select>
//           </div>
          
//           <div className="space-y-2">
//             <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700">
//               From Date
//             </label>
//             <input
//               id="fromDate"
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
          
//           <div className="space-y-2">
//             <label htmlFor="toDate" className="block text-sm font-medium text-gray-700">
//               To Date
//             </label>
//             <input
//               id="toDate"
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
          
//           <div className="pt-4">
//             <button 
//               type="submit" 
//               className="w-full py-2 px-4 bg-primary hover:bg-blue-700 text-white rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//               disabled={isCreating}
//             >
//               {isCreating ? (
//                 <>
//                   <span className="inline-block h-4 w-4 border-2 border-t-transparent border-white rounded-full animate-spin mr-2"></span>
//                   Creating...
//                 </>
//               ) : (
//                 "Create Campaign"
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </>
//   );
// }




import { useState } from "react";
import { retrieveCustomerServiceDetails } from "../hooks/api";


interface CreateCampaignSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  collections: Collection[];
}

interface Collection {
  id: number | string;
  name: string;
}

export function CreateCampaignSidebar({ 
  isOpen, 
  onClose,
  collections = [],
}: CreateCampaignSidebarProps) {
  const [activeTab, setActiveTab] = useState<"crm" | "custom">("crm");
  // CRM Form State
  const [name, setName] = useState("");
  const [collection, setCollection] = useState<string | number>("");
  const [fromDate, setFromDate] = useState<string>(new Date().toISOString().split('T')[0]);
  const [toDate, setToDate] = useState<string>(new Date().toISOString().split('T')[0]);
  
  // Custom Data Form State
  const [customCollectionName, setCustomCollectionName] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string | null>(null);
  
  // Common State
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const API_BASE_URL = "https://interim-cabdemo-module.ispgnet.com";

  const handleCrmSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    
    if (!name.trim()) {
      setError("Campaign name is required");
      return;
    }
    
    if (!collection) {
      setError("Please select a collection");
      return;
    }
    
    if (!fromDate || !toDate) {
      setError("Please select both start and end dates");
      return;
    }
    
    if (new Date(toDate) < new Date(fromDate)) {
      setError("End date cannot be before start date");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const result = await retrieveCustomerServiceDetails({
        fromDate,
        toDate,
        result_collection: name,
      });
      
      setSuccess(`Campaign "${name}" created successfully! ${result.count} records retrieved.`);
      resetCrmForm();
      
      setTimeout(() => {
        onClose();
        setSuccess(null);
      }, 2000);
    } catch (error) {
      console.error("Error creating campaign:", error);
      setError("Failed to create campaign. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCustomSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    
    if (!customCollectionName.trim()) {
      setError("Collection name is required");
      return;
    }
    
    if (!selectedFile) {
      setError("Please select a file to upload");
      return;
    }
    
    const validExtensions = ['.csv', '.xlsx', '.xls'];
    const fileExtension = selectedFile.name.split('.').pop()?.toLowerCase();
    
    if (!fileExtension || !validExtensions.includes(`.${fileExtension}`)) {
      setError("Please upload a valid CSV or Excel file");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('collection_name', customCollectionName);
      
      const response = await fetch("https://interim-cabdemo-module.ispgnet.com/upload_custom_data/", {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error('Upload failed');
      }
      
      const result = await response.json();
      setSuccess(`Data uploaded successfully to collection "${customCollectionName}"! ${result.count} records processed.`);
      resetCustomForm();
      
      // setTimeout(() => {
      //   onClose();
      //   setSuccess(null);
      // }, 2000);
    } catch (error) {
      console.error("Error uploading custom data:", error);
      setError("Failed to upload data. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetCrmForm = () => {
    setName("");
    setCollection("");
    setFromDate(new Date().toISOString().split('T')[0]);
    setToDate(new Date().toISOString().split('T')[0]);
  };

  const resetCustomForm = () => {
    setCustomCollectionName("");
    setSelectedFile(null);
    setFileError(null);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setFileError(null);
    }
  };

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-primary bg-opacity-30 backdrop-blur-sm z-40 animate-fade-in"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <div 
        className={`fixed top-0 right-0 z-50 h-full w-96 max-w-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-xl font-semibold">Create Campaign</h2>
          <button 
            onClick={onClose} 
            className="h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        {/* Toggle Tabs */}
        <div className="flex border-b">
          <button
            className={`flex-1 py-3 font-medium ${activeTab === 'crm' ? 'text-black border-b-2 border-black' : 'text-gray-500'}`}
            onClick={() => setActiveTab('crm')}
          >
            CRM
          </button>
          <button
            className={`flex-1 py-3 font-medium ${activeTab === 'custom' ? 'text-black border-b-2 border-black' : 'text-gray-500'}`}
            onClick={() => setActiveTab('custom')}
          >
            Custom Data
          </button>
        </div>
        
        <div className="p-6">
          {error && (
            <div className="p-3 mb-4 bg-red-50 border border-red-200 text-red-700 rounded-md">
              {error}
            </div>
          )}
          
          {success && (
            <div className="p-3 mb-4 bg-green-50 border border-green-200 text-green-700 rounded-md">
              {success}
            </div>
          )}
          
          {activeTab === 'crm' ? (
            <form onSubmit={handleCrmSubmit} className="space-y-6">
              <div className="space-y-2">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Campaign Name
                </label>
                <input
                  id="name"
                  type="text"
                  placeholder="Enter campaign name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="collection" className="block text-sm font-medium text-gray-700">
                  Collection
                </label>
                <select 
                  id="collection" 
                  value={collection.toString()} 
                  onChange={(e) => setCollection(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                >
                  <option value="" disabled>Select a collection</option>
                  {collections.map((col) => (
                    <option key={col.id.toString()} value={col.id.toString()}>
                      {col.name}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="space-y-2">
                <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700">
                  From Date
                </label>
                <input
                  id="fromDate"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="toDate" className="block text-sm font-medium text-gray-700">
                  To Date
                </label>
                <input
                  id="toDate"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>
              
              <div className="pt-4">
                <button 
                  type="submit" 
                  className="w-full py-2 px-4 bg-primary hover:bg-blue-700 text-white rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="inline-block h-4 w-4 border-2 border-t-transparent border-white rounded-full animate-spin mr-2"></span>
                      Creating...
                    </>
                  ) : (
                    "Create Campaign"
                  )}
                </button>
              </div>
            </form>
          ) : (
            <form onSubmit={handleCustomSubmit} className="space-y-6">
              <div className="space-y-2">
                <label htmlFor="customCollectionName" className="block text-sm font-medium text-gray-700">
                Campaign Name
                </label>
                <input
                  id="customCollectionName"
                  type="text"
                  placeholder="Enter campaign name"
                  value={customCollectionName}
                  onChange={(e) => setCustomCollectionName(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="fileUpload" className="block text-sm font-medium text-gray-700">
                  Upload File (CSV or Excel)
                </label>
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <div className="flex text-sm text-gray-600">
                      <label
                        htmlFor="fileUpload"
                        className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none"
                      >
                        <span>Upload a file</span>
                        <input
                          id="fileUpload"
                          name="fileUpload"
                          type="file"
                          className="sr-only"
                          accept=".csv,.xlsx,.xls"
                          onChange={handleFileChange}
                        />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">
                      CSV or Excel files up to 10MB
                    </p>
                  </div>
                </div>
                {selectedFile && (
                  <div className="text-sm text-gray-700 mt-2">
                    Selected file: {selectedFile.name}
                  </div>
                )}
                {fileError && (
                  <div className="text-sm text-red-600 mt-1">{fileError}</div>
                )}
              </div>
              
              <div className="pt-4">
                <button 
                  type="submit" 
                  className="w-full py-2 px-4 bg-primary hover:bg-blue-700 text-white rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="inline-block h-4 w-4 border-2 border-t-transparent border-white rounded-full animate-spin mr-2"></span>
                      Uploading...
                    </>
                  ) : (
                    "Upload Data"
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}